import React, { useState } from 'react';
import { useCurrentUser } from 'javascripts/hooks';
import { userHasPermission, SHARE_PHOTOS } from 'helpers/permissions';
import GalleryModal from 'components/galleries/GalleryModal';
import { canAccessFeature, FEATURES } from 'helpers/features';
import { useModal } from 'components/shared/hooks';
import { Modal } from 'components/core/modal/constants';
import useCompanyBillingStatus from '../../billing/useCompanyBillingStatus';

const NO_ACTION = null;
const NO_MODAL = () => {};
const EMPTY_RESULT = [NO_ACTION, NO_MODAL];

const databaseIdFrom = (obj) => parseInt(obj.databaseId, 10);

export default function useMenuActionShareGallery({ assets, assetsByType }) {
  const [modalVisible, setModalVisible] = useState(false);
  const { showModal, hideModal } = useModal();
  const { featureSet } = useCompanyBillingStatus();
  const canAccessGalleryLinks = canAccessFeature(featureSet, FEATURES.GALLERY_LINKS);

  const user = useCurrentUser();

  const hasPermission = userHasPermission(user, SHARE_PHOTOS);
  const validSelection = assets.length > 0;

  if (!hasPermission || !validSelection) {
    return EMPTY_RESULT;
  }

  const action = () => {
    setModalVisible(true);
  };

  const actionOrUpgrade = canAccessGalleryLinks
    ? action
    : () =>
        showModal(Modal.UPGRADE_GALLERY_LINKS, {
          onRequestClose: () => hideModal(),
        });

  const renderModal = modalVisible && (
    <GalleryModal
      onRequestClose={() => {
        setModalVisible(false);
      }}
      photoDatabaseIds={assetsByType.photos.map(databaseIdFrom)}
      videoDatabaseIds={assetsByType.videos.map(databaseIdFrom)}
    />
  );

  return [actionOrUpgrade, canAccessGalleryLinks, renderModal];
}
